import { ChipIcon } from './ChipIcon';

/**
 * author: Austin Andrews
 * id A535271B-1114-44AD-9D9D-1984905026FF
 * name chip
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chip.svg
 * tags
 */
export const IntegratedCircuitIcon = ChipIcon;
export default IntegratedCircuitIcon